// HeatmapSkeleton.js — pulsing placeholder grid shown while data loads.
// Keeps layout stable so the real grid doesn't jolt into place.

import React from "react";
import { Box } from "@mui/material";
import { shimmer } from "../../styles/animations";

const ROWS = 8;
const COLS = 10;

export default function HeatmapSkeleton({ cellSize = 64, isMobile = false }) {
  const size = isMobile ? 36 : cellSize;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", pt: 6, pb: 4 }}
    >
      <Box>
        {Array.from({ length: ROWS }).map((_, r) => (
          <Box key={r} display="flex">
            {Array.from({ length: COLS }).map((_, c) => (
              <Box
                key={c}
                sx={{
                  width: size,
                  height: size,
                  m: "1px",
                  borderRadius: "4px",
                  background:
                    "linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(111,93,245,0.22) 50%, rgba(255,255,255,0.04) 100%)",
                  backgroundSize: "800px 100%",
                  animation: `${shimmer} 1.6s linear infinite`,
                  animationDelay: `${(r + c) * 40}ms`,
                }}
              />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
